<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :tableKey="tableKey"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        :defaults.sync="defaults"
        v-model="form"
        @on-load="getPage"
        @row-save="handleSave"
        @selection-change="handleSelectionChange"
        @refresh-change="refreshChange"
        @sort-change="sortChange"
        @search-change="searchChange"
      >
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              v-if="permissions['chain:ledgerDig:excel']"
              style="margin-right: 20px; margin-bottom: 0"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>

            <div class="expand" @click="expandSearch">
              <span v-if="isExpand == true"
                >收起 <i class="el-icon-arrow-up"></i
              ></span>
              <span v-if="isExpand == false"
                >展开 <i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </div>
        </template>
        <template slot="companyPositionIdSearchLabel">
          <div class="search-label">台班审核:</div>
          <div class="search-desc">(按岗位)</div>
        </template>
        <template slot="menuLeft" slot-scope="{ row }">
          <!-- <div style=""> -->
          <div class="checked">
            <el-checkbox
              :value="multipleSelection.length > 0"
              @change="changeAll"
              style="margin-right: 8px"
            ></el-checkbox>
            已选<span> {{ multipleSelection.length }} </span>个
          </div>
          <el-button
            v-if="permissions['chain:ledgerDig:pass']"
            size="mini"
            :disabled="multipleSelection.length == 0"
            @click="batchApprove"
          >
            批量通过
          </el-button>
          <el-button
            v-if="permissions['chain:ledgerDig:reject']"
            size="mini"
            :disabled="multipleSelection.length == 0"
            @click="batchReject"
          >
            批量驳回
          </el-button>
          <!-- <el-button
              icon="el-icon-close"
              v-if="permissions['chain:ledgerDig:del']"
              size="mini"
              type="primary"
              :disabled="multipleSelection.length == 0"
              @click="batchDel"
            >
              批量删除
            </el-button> -->
          <!-- <el-button icon="el-icon-download" v-if="permissions['chain:ledgerDig:excel']" size="mini" type="primary"
              @click="exOut">
              导出
            </el-button> -->
          <el-button
            v-if="permissions['chain:ledgerDig:remark']"
            size="mini"
            :disabled="multipleSelection.length == 0"
            @click="setRemark('')"
          >
            批量设置PC后台备注
          </el-button>
          <el-button
            size="mini"
            v-if="permissions['chain:ledgerDig:setLedgerPrice']"
            :disabled="multipleSelection.length == 0"
            @click="batchSetLedgerPrice('')"
          >
            批量设置台班价
          </el-button>
          <el-button
            size="mini"
            type="primary"
            v-if="permissions['chain:ledgerDig:add']"
            @click="addLedger"
          >
            新增
          </el-button>
          <!-- </div> -->
        </template>
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            v-if="permissions['chain:ledgerDig:pass'] && row.auditAuth"
            size="small"
            plain
            @click="approve(row)"
          >
            审核通过</el-button
          >
          <el-button
            type="text"
            v-if="permissions['chain:ledgerDig:reject'] && row.auditAuth"
            size="small"
            plain
            @click="reject(row)"
          >
            驳回</el-button
          >
          <!-- <el-button
            type="text"
            v-if="permissions['chain:ledgerDig:del'] && (row.ledgerStatus==9||(row.ledgerStatus == 2&&row.ledgerType!='签证'))"
            icon="el-icon-delete"
            size="small"
            plain
            @click="handleDel(row)"
          >
            删除</el-button
          > -->
          <el-button
            type="text"
            v-if="permissions['chain:ledgerDig:remark']"
            size="small"
            plain
            @click="setRemark(row)"
          >
            设置PC后台备注</el-button
          ><el-button
            size="small"
            type="text"
            plain
            v-if="permissions['chain:ledgerDig:setLedgerPrice']"
            @click="batchSetLedgerPrice(row)"
          >
            设置台班价
          </el-button>
          <!-- <el-button
            type="text"
            icon="el-icon-notebook-2"
            v-if="permissions['chain:ledgerDig:history'] && row.hasHistory == 1"
            size="small"
            plain
            @click="getHistory(row)">
            历史记录</el-button> -->
          <el-button
            type="text"
            v-if="permissions['chain:ledgerDig:view']"
            size="small"
            plain
            @click="getFlow(row)"
          >
            查看</el-button
          >
        </template>
        <!-- <template slot="menuLeft" slot-scope="scope">
          <div class="statistics">
            <label>合计工作时长：</label><span>{{ totalWorkingHours }}小时</span>
          </div>
        </template> -->
      </avue-crud>
      <historyRecord
        v-if="historyVisible"
        :visible.sync="historyVisible"
        :info="info"
      ></historyRecord>
      <flowView
        v-if="flowVisible"
        :visible.sync="flowVisible"
        :info="info"
      ></flowView>

      <!-- 设置装车价 -->
      <el-dialog
        title="设置装车价"
        custom-class="pc-dialog"
        width="480px"
        :visible.sync="loadingPriceVisible"
      >
        <el-form
          :model="loadingPriceForm"
          :rules="loadingPriceRules"
          ref="loadingPriceForm"
        >
          <el-form-item prop="price">
            <el-input
              placeholder="请输入装车价"
              type="number"
              v-model="loadingPriceForm.price"
            >
              <template slot="prepend">￥</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="loadingPriceVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="batchUpdateInPreparePrice('loadingPriceForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        width="548px"
        :close-on-click-modal="false"
        :visible.sync="checkPassVisible"
      >
        <template slot="title">
          <div class="check-title">
            <i
              class="el-icon-info"
              style="color: #35b1ff; margin-right: 8px"
            ></i>
            确定审核{{auditType==1?'通过':'驳回'}}吗？
          </div>
        </template>
        <div class="desc" v-if="isBatch">
          已选择 {{multipleSelection.length}} 个台班，确定审核{{auditType==1?'通过':'驳回'}}吗？
        </div>
        <div class="check-remark" v-if="isCheckRemark">
          <div class="check-textarea">
            <textarea
              v-model="auditForm.auditRemark"
              name=""
              id=""
              cols="30"
              rows="5"
              maxlength="100"
              :placeholder="`请输入${auditType==1?'通过':'驳回'}理由(选填)`"
            ></textarea>
            <div class="num">{{ auditForm.auditRemark.length }}/100</div>
          </div>
          <el-upload
            action="/upms/file/upload?fileType=image&dir=batchRecharge/"
            v-if="!isBatch"
            list-type="picture-card"
            :headers="headers"
            :file-list="fileList"
            multiple
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handleError"
            :limit="9"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              建议尺寸 900*400，最多 9 张，单个图片不超过 20M。
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isCheckRemark = true" v-if="!isCheckRemark">添加备注</el-button>
          <el-button @click="checkPassVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 设置PC备注 -->
      <el-dialog
        title="设置PC备注"
        width="480px"
        custom-class="pc-dialog"
        :visible.sync="pcRemarkVisible"
      >
        <el-form
          :model="pcRemarkForm"
          :rules="pcRemarkRules"
          ref="pcRemarkForm"
        >
          <el-form-item prop="remark">
            <el-input
              type="textarea"
              v-model="pcRemarkForm.remark"
              placeholder="请输入PC备注"
              maxlength="100"
              show-word-limit
              rows="4"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pcRemarkVisible = false">取 消</el-button>
          <el-button type="primary" @click="editPcRemark('pcRemarkForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 审核 -->
      <!-- <auditForm
        v-if="auditVisible"
        :detailForm="auditForm"
        :option="auditOption"
        dialogType="elDialog"
        :showCancel="true"
        ref="auditForm"
        size="430px"
        :visible.sync="auditVisible"
        @submit="submit"
        :title="title"
      >
      </auditForm> -->
    </basic-container>
  </div>
</template>

<script>
import {
  getWorkFlowPage as getPage,
  delObj,
  passObj,
  batchRejectByCheckStaff,
  getSettingAll,
  editPcLedgerRemark,
  batchEditPrice,
  getWorkTimeStatistic,
  batchConfirmByCheckStaff,
  addForWorkflow,
} from "@/api/chain/ledgerDig2";
import { tableOption } from "@/const/crud/chain/ledgerDig2";
import { mapGetters } from "vuex";
import { exportOut } from "@/util/down.js";
import historyRecord from "./historyRecord.vue";
import flowView from "./flowView.vue";
// import auditForm from "@/components/formDetail/index.vue";
import store from "@/store";
export default {
  name: "ledgerDig2",
  components: { historyRecord, flowView },
  data() {
    return {
      tableKey:0,
      isBatch:false,
      fileList:[],
      headers: {
        Authorization: "Bearer " + store.getters.access_token,
        AuthorizationMD5: store.getters.user_md5, // user_md5
      },
      auditForm: {
        auditRemark: "",
      },
      isCheckRemark: false,
      textarea: "",
      checkPassVisible: false,
      loadingPriceVisible: false,
      loadingPriceForm: {
        price: "",
      },
      loadingPriceRules: {
        price: [{ required: true, message: "请输入装车价", trigger: "blur" }],
      },
      pcRemarkRules: {
        remark: [{ required: true, message: "请输入PC备注", trigger: "blur" }],
      },
      curRowData: {},
      pcRemarkVisible: false,
      pcRemarkForm: {
        remark: "",
      },
      isExpand: false,
      form: {
        isVisa: 0,
        isSubsidizedMeals: 0,
      },
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: "start_datetime", //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption(this),
      multipleSelection: [],
      defaults: {},
      historyVisible: false,
      flowVisible: false,
      info: {},
      totalWorkingHours: 0,
      title: "提示",
      auditVisible: false, //审核
      auditOption: {
        labelWidth: 100,
        emptyBtn: false,
        labelPosition: "top",
        gutter: 0,
        column: [
          {
            label: "备注",
            prop: "auditRemark",
            type: "textarea",
            minRows: 3,
            maxRows: 5,
            span: 24,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: "请输入 备注",
                trigger: "blur",
              },
            ],
          },
          {
            label: "补充照片",
            prop: "approvePictureUrl",
            type: "upload",
            listType: "picture-card",
            action: "/upms/file/upload?fileType=image&dir=batchRecharge/",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            accept: ".jpg,.png",
            loadText: "附件上传中，请稍等",
            span: 24,
            tip: "只能上传jpg/png文件",
          },
        ],
      },
      ids: "",
      auditType: 1,
    };
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  mounted() {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
    // this.tableOption = tableOption(this)
    this.getPermiss();
    this.tableOption.column.forEach((item) => {
      if (item.prop == "companyPositionId") {
        item.search = this.permissions["chain:ledgerDig:jobSearch"];
      }
    });
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:ledgerDig:add"] ? true : false,
        delBtn: this.permissions["chain:ledgerDig:del"] ? true : false,
        editBtn: this.permissions["chain:ledgerDig:edit"] ? true : false,
        viewBtn: this.permissions["chain:ledgerDig:get"] ? true : false,
        excelBtn: this.permissions["chain:ledgerDig:excel"] ? true : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    resetCheck(){
      this.isCheckRemark=false
      this.checkPassVisible=true
      this.auditForm={
        auditRemark:''
      }
      this.fileList=[]
    },
    handleRemove(file, fileList){
      this.fileList=fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList=fileList
    },
    handleError(err, file, fileList) {
      this.$message.error(err + "");
    },
    beforeUpload(file) {
      const isPic =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isPic) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG、GIF 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isPic && isLt2M;
    },
    batchUpdateInPreparePrice(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = {
            ledgerIds: this.curRowData
              ? [this.curRowData.id]
              : this.multipleSelection.map((item) => item.id),
            preparePrice: this.loadingPriceForm.price,
          };
          batchEditPrice(arr).then((res) => {
            this.$message.success("操作成功");
            this.loadingPriceVisible = false;
            this.loadingPriceForm.price = "";
            this.getPage(this.page);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editPcRemark(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = [];
          if (this.curRowData) {
            arr = [
              {
                id: this.curRowData.id,
                pcLedgerRemark: this.pcRemarkForm.remark,
              },
            ];
          } else {
            arr = this.multipleSelection.map((item) => {
              return {
                id: item.id,
                pcLedgerRemark: this.pcRemarkForm.remark,
              };
            });
          }

          editPcLedgerRemark(arr).then((res) => {
            this.$message.success("操作成功");
            this.pcRemarkVisible = false;
            this.pcRemarkForm.remark = "";
            this.getPage(this.page);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeAll(e) {
      if (e) {
        this.$refs.crud.$refs.table.toggleAllSelection();
      } else {
        this.multipleSelection = [];
        this.$refs.crud.$refs.table.clearSelection();
      }
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    expandSearch() {
      this.$refs.crud.$refs.headerSearch.show =
        !this.$refs.crud.$refs.headerSearch.show;
      this.isExpand = this.$refs.crud.$refs.headerSearch.show;
    },
    handleSave(row, done, loading) {
      console.info(row);
      row.inShiftType = row.inShiftTypeForm;
      row.ledgerType = row.ledgerTypeForm;
      row.unitWork = row.unitWorkForm;
      row.beginClockUrl =
        Array.isArray(row.beginClockUrl) && row.beginClockUrl.length == 0
          ? ""
          : row.beginClockUrl;
      row.endClockUrl =
        Array.isArray(row.endClockUrl) && row.endClockUrl.length == 0
          ? ""
          : row.endClockUrl;
      row.shiftTime = row.inShiftTime;
      addForWorkflow(row)
        .then((res) => {
          this.$message.success("新增成功");
          this.getPage(this.page);
          done();
        })
        .catch(() => {
          loading();
        });
    },
    addLedger() {
      this.$router.push({
        path: "/addLedgerDig",
      });
      // this.$refs.crud.rowAdd();
    },
    batchEditPrice(data) {
      batchEditPrice(data).then((res) => {
        this.$message.success("操作成功");
        this.getPage(this.page);
      });
    },

    batchSetLedgerPrice(row) {
      this.curRowData = row;
      this.loadingPriceVisible = true;
      // this.$prompt("设置台班价", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputType: "number",
      //   // inputPattern:/^[0-9]+(\.[0-9]{1,2})?$/,
      //   inputPlaceholder: "请设置台班价",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "台班价不能为空";
      //     } else if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
      //       return "请输入两位小数";
      //     }
      //   },
      //   // inputErrorMessage: "请输入台班价",
      // })
      //   .then(({ value }) => {
      //     let data = {};
      //     if (row.id) {
      //       data = {
      //         preparePrice: value,
      //         ledgerIds: [row.id],
      //       };
      //     } else {
      //       data = {
      //         preparePrice: value,
      //         ledgerIds: this.multipleSelection.map((v) => v.id),
      //       };
      //     }

      //     this.batchEditPrice(data);
      //   })
      //   .catch(() => {});
    },
    getPermiss() {
      getSettingAll().then((res) => {
        console.info(res);
        console.log(this.$refs.crud);
        this.tableOption.column.forEach((item) => {
          if (item.prop == "isVisa") {
            item.search = false;
          }
        });
        let arr = [
          "beginClockUrl",
          "beginClock",
          "endClockUrl",
          "endClock",
          "refuelingLitres",
          "cost",
          "isSubsidizedMeals",
          "overtimeHours",
          "isVisa",
        ];
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            if (arr.includes(item.key)) {
              this.tableOption.column.forEach((item1) => {
                if (item1.prop === item.key) {
                  item1.display = true;
                }
              });
              this.defaults[item.key].hide = false;
              this.defaults[item.key].showColumn = true;
            }
            if (item.key == "isVisa") {
              this.tableOption.column.forEach((item) => {
                if (item.prop == "isVisa") {
                  item.search = true;
                }
              });
            }
          });
        }
      });
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startDate = params.searchDate[0];
          params.endDate = params.searchDate[1];
          delete params.searchDate;
        }
        if (params.hasOwnProperty("inShiftTime")) {
          params.inShiftTimeStart = params.inShiftTime[0];
          params.inShiftTimeEnd = params.inShiftTime[1];
          delete params.inShiftTime;
        }
      }
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
      this.getWorkTimeStatistic(params);
    },
    getWorkTimeStatistic(params = {}) {
      getWorkTimeStatistic(Object.assign(params, this.paramsSearch)).then(
        (res) => {
          this.totalWorkingHours = res.data.data;
        }
      );
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj([row.id]);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    batchDel() {
      let isTrue = this.multipleSelection.every((item) => {
        return item.auditAuth;
      });
      if (!isTrue) {
        return this.$message.error("请选择需要审核的台班进行操作");
      }
      let _this = this;
      this.$confirm(
        `是否确认删除这${this.multipleSelection.length}条数据`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function () {
          return delObj(_this.multipleSelection.map((item) => item.id));
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    //批量审核通过
    batchApprove() {
      let isTrue = this.multipleSelection.every((item) => {
        return item.auditAuth;
      });
      if (!isTrue) {
        return this.$message.error("请选择需要审核的台班进行操作");
      }
      // let column = this.auditOption.column[0];
      // this.title = `是否确认将这${this.multipleSelection.length}条数据审批通过`;
      // column.placeholder = `请输入通过理由`;
      // column.rules = [
      //   {
      //     required: false,
      //     message: "请输入通过理由",
      //     trigger: "blur",
      //   },
      // ];
      this.ids = this.multipleSelection.map((item) => item.id).join(",");
      this.auditType = 1;
      this.isBatch=true
      this.resetCheck()
      // let _this = this;
      // this.$prompt(
      //   `是否确认将这${this.multipleSelection.length}条数据审批通过`,
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPlaceholder: "请输入备注内容",
      //     inputValidator: (value) => {
      //       if (value && value.length > 100) {
      //         return "超出限制字数100";
      //       }
      //     },
      //     inputErrorMessage: "请输入备注内容",
      //   }
      // )
      //   .then(function ({ value }) {
      //     return batchConfirmByCheckStaff({
      //       auditRemark: value,
      //       ledgerIds: _this.multipleSelection.map((item) => item.id).join(","),
      //     });
      //   })
      //   .then((data) => {
      //     _this.$message({
      //       showClose: true,
      //       message: "审核通过成功",
      //       type: "success",
      //     });
      //     this.getPage(this.page);
      //   })
      //   .catch(function (err) {});
    },
    //审核通过
    approve(row) {
      // let column = this.auditOption.column[0];
      // this.title = `是否确认审核通过此数据`;
      // column.placeholder = `请输入通过理由`;
      // column.rules = [
      //   {
      //     required: false,
      //     message: "请输入通过理由",
      //     trigger: "blur",
      //   },
      // ];
      this.ids = row.id;
      this.auditType = 1;
      this.isBatch=false
      this.resetCheck()
      // let _this = this;
      // this.$prompt(`是否确认审核通过此数据`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPlaceholder: "请输入备注内容",
      //   inputValidator: (value) => {
      //     if (value && value.length > 100) {
      //       return "超出限制字数100";
      //     }
      //   },
      //   inputErrorMessage: "请输入备注内容",
      // })
      //   .then(function ({ value }) {
      //     return batchConfirmByCheckStaff({
      //       auditRemark: value,
      //       ledgerIds: row.id,
      //     });
      //   })
      //   .then((data) => {
      //     _this.$message({
      //       showClose: true,
      //       message: "审核通过成功",
      //       type: "success",
      //     });
      //     this.getPage(this.page);
      //   })
      //   .catch(function (err) { });
    },
    //批量审核驳回
    batchReject() {
      let isTrue = this.multipleSelection.every((item) => {
        return item.auditAuth;
      });
      if (!isTrue) {
        return this.$message.error("请选择需要审核的台班进行操作");
      }
      // let column = this.auditOption.column[0];
      // this.title = `是否确认将这${this.multipleSelection.length}条数据驳回`;
      // column.placeholder = `请输入驳回理由`;
      // column.rules = [
      //   {
      //     required: true,
      //     message: "请输入驳回理由",
      //     trigger: "blur",
      //   },
      // ];
      this.ids = this.multipleSelection.map((item) => item.id).join(",");
      this.auditType = 2;
      this.isBatch=true
      this.resetCheck()
      this.isCheckRemark = true;
      // let _this = this;
      // const h = this.$createElement;
      // this.$prompt(
      //   h("p", null, [
      //     h("i", { style: "color: red" }, "* "),
      //     h(
      //       "span",
      //       null,
      //       `是否确认将这${this.multipleSelection.length}条数据驳回`
      //     ),
      //   ]),
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPlaceholder: "请输入备注内容",
      //     inputPattern: /\S/,
      //     inputValidator: (value) => {
      //       if (value && value.length > 100) {
      //         return "超出限制字数100";
      //       }
      //     },
      //     inputErrorMessage: "请输入备注内容",
      //   }
      // )
      //   .then(function ({ value }) {
      //     return batchRejectByCheckStaff({
      //       auditRemark: value,
      //       ledgerIds: _this.multipleSelection.map((item) => item.id).join(","),
      //     });
      //   })
      //   .then((data) => {
      //     _this.$message({
      //       showClose: true,
      //       message: "驳回成功",
      //       type: "success",
      //     });
      //     this.getPage(this.page);
      //   })
      //   .catch(function (err) { });
    },
    //驳回
    reject(row) {
      // let column = this.auditOption.column[0];
      // this.title = `是否确认驳回此数据`;
      // column.placeholder = `请输入驳回理由`;
      // column.rules = [
      //   {
      //     required: true,
      //     message: "请输入驳回理由",
      //     trigger: "blur",
      //   },
      // ];
      
      this.ids = row.id;
      this.auditType = 2;
      this.isBatch=false
      this.resetCheck()
      this.isCheckRemark = true;
      // let _this = this;
      // const h = this.$createElement;
      // this.$prompt(
      //   h("p", null, [
      //     h("i", { style: "color: red" }, "* "),
      //     h("span", null, " 是否确认驳回此数据"),
      //   ]),
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPlaceholder: "请输入备注内容",
      //     inputPattern: /\S/,
      //     inputValidator: (value) => {
      //       if (value && value.length > 100) {
      //         return "超出限制字数100";
      //       }
      //     },
      //     inputErrorMessage: "请输入备注内容",
      //   }
      // )
      //   .then(function ({ value }) {
      //     return batchRejectByCheckStaff({
      //       auditRemark: value,
      //       ledgerIds: row.id,
      //     });
      //   })
      //   .then((data) => {
      //     _this.$message({
      //       showClose: true,
      //       message: "驳回成功",
      //       type: "success",
      //     });
      //     this.getPage(this.page);
      //   })
      //   .catch(function (err) { });
    },
    submit(form, done) {
      console.info(this.fileList)
      // 提交
      this.auditForm.ledgerIds = this.ids;
      this.auditForm.approvePictureUrl=this.fileList.map(v=>v.response.link).join(',')
      if (this.auditType == 1) {
        batchConfirmByCheckStaff(this.auditForm)
          .then((data) => {
            this.checkPassVisible = false;
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
            this.getPage(this.page);
          })
          .catch(function (err) {});
      } else {
        batchRejectByCheckStaff(this.auditForm)
          .then((data) => {
            this.checkPassVisible = false;
            this.$message({
              showClose: true,
              message: "驳回成功",
              type: "success",
            });
            this.getPage(this.page);
          })
          .catch(function (err) {});
      }
    },
    getHistory(row) {
      this.info = row;
      this.historyVisible = true;
    },
    getFlow(row) {
      this.info = row;
      this.flowVisible = true;
    },
    exOut() {
      let params = Object.assign({}, this.paramsSearch);
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startDate = params.searchDate[0];
          params.endDate = params.searchDate[1];
          delete params.searchDate;
        }
        if (params.hasOwnProperty("inShiftTime")) {
          params.inShiftTimeStart = params.inShiftTime[0];
          params.inShiftTimeEnd = params.inShiftTime[1];
          delete params.inShiftTime;
        }
      }
      let url = "/chain/ledgerDig/exportExcavatorStageCrewExcel";
      exportOut(params, url, "挖机台班管理", "post");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchSetRemark() {
      this.$prompt("PC后台备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入PC后台备注",
        inputValidator: (value) => {
          if (!value) {
            return "PC后台备注不能为空";
          }
        },
        inputErrorMessage: "请输入PC后台备注",
      })
        .then(({ value }) => {
          let arr = this.multipleSelection.map((item) => {
            return {
              id: item.id,
              pcLedgerRemark: value,
            };
          });
          this.editPcLedgerRemark(arr);
        })
        .catch(() => {});
    },

    setRemark(row) {
      this.curRowData = row;
      this.pcRemarkVisible = true;
      // this.$prompt("PC后台备注", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPlaceholder: "请输入PC后台备注",
      //   inputValue: row.pcLedgerRemark || "",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "PC后台备注不能为空";
      //     }
      //   },
      //   inputErrorMessage: "请输入PC后台备注",
      // })
      //   .then(({ value }) => {
      //     this.editPcLedgerRemark([
      //       {
      //         id: row.id,
      //         pcLedgerRemark: value,
      //       },
      //     ]);
      //   })
      //   .catch(() => {});
    },
    editPcLedgerRemark(arr) {
      editPcLedgerRemark(arr).then((res) => {
        this.$message.success("操作成功");
        this.getPage(this.page);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics {
  line-height: 40px;
  color: #606266;

  span {
    color: red;
    margin-right: 20px;
  }
}


/deep/ .el-dialog__body .el-upload-list__item {
  width: 80px;
  height: 80px;
  line-height: 90px;
}

/deep/ .el-dialog__body .avue-form__item--top .el-form-item__label {
  padding-bottom: 0;
}
</style>
<style lang="scss" scoped>
@import "@/styles/newPage.scss";
/deep/.headerContent ~ .el-button {
  display: none;
}
/deep/.avue-crud__tip {
  display: none;
}
/deep/.avue-crud__left {
  display: flex;
  align-items: center;
  .el-button {
    margin-bottom: 0;
  }
}
.check-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
}
.check-remark {
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ededf0;
  padding: 6px 10px;
  .check-textarea {
    position: relative;
    .num {
      position: absolute;
      right: 10px;
      bottom: 15px;
      font-weight: 400;
      font-size: 12px;
      color: #323233;
    }
  }
  textarea {
    border: none;

    margin-right: 30px;
    width: calc(100% - 10px);
    box-sizing: border-box;
  }
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 90px;
  background: #F5F7FA;
}
.el-upload__tip {
  font-weight: 400;
  font-size: 14px;
  color: #939399;
}
.desc{
  margin-top: -30px;
  font-weight: 400;
font-size: 14px;
color: #626266;
margin-bottom: 16px;
}
.headerContent{
  margin-left: 120px;
}
</style>
